import { Spin } from "antd";
import React from "react";

const LoadingConfig = ({ title = "Waiting..." }) => {
  return (
    <div className="loadingConfig">
      <Spin size="large" />

      <div className="text">{title}</div>
    </div>
  );
};
export default LoadingConfig;
